import React from 'react'
import s from './styles/RecommendationAttachment.module.scss'

export default function UniversityRecommendationCard({ item }) {
	const url = item?.url || ''
	return (
		<div className={s.item}>
			<strong className={s.itemTitle}>{item?.title || 'University program'}</strong>
			{url ? (
				<a
					className={s.itemLink}
					href={url}
					target="_blank"
					rel="noreferrer"
				>
					{url}
				</a>
			) : null}
		</div>
	)
}
